import { TableCell, TableSortLabel, type TableCellProps } from "@mui/material";
import React from "react";

export type TableSortDirection = "asc" | "desc";

interface SortableTableCellProps<TColumn extends string> extends TableCellProps {
  activeColumn: TColumn | null;
  column: TColumn;
  direction: TableSortDirection;
  onSort: (column: TColumn) => void;
  children: React.ReactNode;
}

/** A consistent sortable header cell for standalone admin list tables. */
export const SortableTableCell = <TColumn extends string>({
  activeColumn,
  column,
  direction,
  onSort,
  children,
  ...tableCellProps
}: SortableTableCellProps<TColumn>) => (
  <TableCell {...tableCellProps}>
    <TableSortLabel
      active={activeColumn === column}
      direction={activeColumn === column ? direction : "asc"}
      onClick={() => onSort(column)}
    >
      {children}
    </TableSortLabel>
  </TableCell>
);
